import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

const BackArrow = ({ to, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`
        inline-flex items-center justify-center
        text-gray-700 hover:text-theme-primary
        transition-colors
        ${className}
      `}
      aria-label="Go back"
    >
      <MdArrowBack className="text-xl" />
    </button>
  );
};

export default BackArrow;
